import { render, staticRenderFns } from "./nlp-analysis-configuration.html?vue&type=template&id=1017420e&scoped=true&"
import script from "./nlp-analysis-configuration.js?vue&type=script&lang=js&"
export * from "./nlp-analysis-configuration.js?vue&type=script&lang=js&"
import style0 from "./nlp-analysis-configuration.scss?vue&type=style&index=0&id=1017420e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1017420e",
  null
  
)

export default component.exports